import React from 'react';
import { Box, Button } from '@mui/material';
import { Link as RouterLink, Outlet } from 'react-router-dom';
import { useFeature } from '../EnvironmentContext';
import PageSkeleton from './PageSkeleton';

const MsApproveOperationsLayout: React.FC = () => {
  const reportingEnabled = useFeature('Reports.ApprovalPerformance');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      {reportingEnabled && (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', borderBottom: 1, borderColor: 'divider', flexShrink: 0, px: 2 }}>
          <Button component={RouterLink} to="/reports/approval-performance#decision-history">Approval reporting</Button>
        </Box>
      )}
      <Box sx={{ flex: 1, overflow: 'auto', minWidth: 0 }}>
        <React.Suspense fallback={<PageSkeleton />}>
          <Outlet />
        </React.Suspense>
      </Box>
    </Box>
  );
};

export default MsApproveOperationsLayout;

